// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"5b7758ab0a39d39b28ea","691":"32566f6e9862e20df57f"}[chunkId] + ".js";
};